import { PopupPayload } from './popups';
import { PortalStyleConfig } from './portal-theme';
import { ThemeColorSchemas } from './theme-color-schemas';

export enum ModalTitleSize {
  XL = 'xl',
  LG = 'lg',
  MD = 'md',
  SM = 'sm',
}

export interface ModalState {
  id: number;
  isShown?: boolean;
  title?: string;
  content?: string;
  showCloseButton?: boolean;
  closeButtonSize?: number;
  titleSize?: ModalTitleSize;
  isFullScreen?: boolean;
  usePadding?: boolean;
  payload?: PopupPayload;
  position?: MenuPosition | false;
  additionalLayoutStyles?: string;
  modalContainerStyles?: string;
  escapeToClose?: boolean;
  modalGradient?: string;
  disabledClose?: boolean;
  themeColors?: ThemeColorSchemas;
  themeStyle?: PortalStyleConfig;
  onClose?: () => void;
  zIndex?: number;
  multipopup?: boolean;
}
export type OpenModalParams = Omit<ModalState, 'id'>;

export type OpenModalFn = (params?: OpenModalParams) => void;

export type MenuPosition = ({ top: string } | { bottom: string }) & ({ left: string } | { right: string });
